(function () {
  'use strict';

  var activePopup = null;
  var activeTrigger = null;
  var namespace = window.FN0019 = window.FN0019 || {};

  namespace.handleQuickAddForm = function (form, submitter) {
    var wrapper = getPopupWrapper(form);

    if (!wrapper) return false;

    addQuickProduct(form, wrapper, submitter);

    return true;
  };

  document.addEventListener('submit', handleQuickAddSubmit, true);
  document.addEventListener('keydown', handleKeydown);
  processQueuedSubmits();

  function handleQuickAddSubmit(event) {
    var form = event.target;
    var wrapper = getPopupWrapper(form);

    if (!wrapper) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    namespace.handleQuickAddForm(form, event.submitter);
  }

  function getPopupWrapper(form) {
    if (!form || !form.matches('form[action*="/cart/add"]')) return null;

    var wrapper = form.closest('.quick-add-wrapper.is-singular');
    if (!wrapper || !wrapper.querySelector('[data-fn-0019-template]')) return null;

    return wrapper;
  }

  function addQuickProduct(form, wrapper, submitter) {
    var button = submitter && submitter.matches('.quick-add-button') ? submitter : form.querySelector('.quick-add-button');

    setButtonLoading(button, true);

    fetch(getCartAddUrl(), getFetchConfig(form))
      .then(function (response) {
        return response.json().then(function (responseJson) {
          return {
            ok: response.ok,
            responseJson: responseJson
          };
        });
      })
      .then(function (result) {
        if (!result.ok) return;

        updateCartDrawer(result.responseJson);
        updateCartCount();
        openPopup(wrapper.querySelector('[data-fn-0019-template]'), button);
      })
      .catch(function () {
        renderCartDrawer();
      })
      .finally(function () {
        setButtonLoading(button, false);
      });
  }

  function getCartAddUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;

    return '/cart/add.js';
  }

  function getFetchConfig(form) {
    var formData = new FormData(form);

    if (!formData.has('sections') && getPageContainer().dataset.cartType === 'drawer') {
      formData.append('sections', 'cart-drawer');
    }

    return {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };
  }

  function updateCartDrawer(responseJson) {
    if (!window.eventBus || !responseJson || !responseJson.sections) return;

    window.eventBus.emit('update:cart:drawer', responseJson);
  }

  function renderCartDrawer() {
    if (!window.eventBus) return;

    window.eventBus.emit('render:cart:drawer');
  }

  function updateCartCount() {
    if (!window.wetheme || typeof window.wetheme.updateCartCount !== 'function') return;

    fetch(getCartUrl())
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        window.wetheme.updateCartCount(cart);
      })
      .catch(function () {});
  }

  function getCartUrl() {
    var pageContainer = getPageContainer();
    var languageUrl = pageContainer.dataset.languageUrl;
    var languageParam = !languageUrl || languageUrl === '/' ? '' : languageUrl;

    return languageParam + '/cart?view=compare';
  }

  function openPopup(template, trigger) {
    if (!template) return;

    closePopup();

    var fragment = template.content.cloneNode(true);
    var popup = fragment.querySelector('.fn-0019');
    var cartButton = fragment.querySelector('[data-fn-0019-cart]');
    var closeButtons = fragment.querySelectorAll('[data-fn-0019-close]');

    activeTrigger = trigger || document.activeElement;
    activePopup = popup;

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    if (cartButton) {
      cartButton.addEventListener('click', openCart);
    }

    document.body.appendChild(fragment);
    document.documentElement.classList.add('fn-0019-open');

    if (popup) popup.focus();
  }

  function closePopup() {
    document.querySelectorAll('.fn-0019, .fn-0019-overlay').forEach(function (element) {
      element.remove();
    });

    document.documentElement.classList.remove('fn-0019-open');

    if (activeTrigger && typeof activeTrigger.focus === 'function') {
      activeTrigger.focus();
    }

    activePopup = null;
    activeTrigger = null;
  }

  function openCart() {
    closePopup();

    if (getPageContainer().dataset.cartType === 'drawer' && window.eventBus) {
      window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
      return;
    }

    if (window.routes && window.routes.cart_url) {
      window.location.href = window.routes.cart_url;
      return;
    }

    window.location.href = '/cart';
  }

  function handleKeydown(event) {
    if (!activePopup || event.key !== 'Escape') return;

    closePopup();
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    if (!button.dataset.fn0019OriginalHtml) {
      button.dataset.fn0019OriginalHtml = button.innerHTML;
    }

    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);

    if (!isLoading) {
      button.innerHTML = button.dataset.fn0019OriginalHtml;
      delete button.dataset.fn0019OriginalHtml;
    }
  }

  function getPageContainer() {
    return document.querySelector('#PageContainer') || document.documentElement;
  }

  function processQueuedSubmits() {
    if (!Array.isArray(namespace.queuedSubmits)) return;

    namespace.queuedSubmits.splice(0).forEach(function (queuedSubmit) {
      namespace.handleQuickAddForm(queuedSubmit.form, queuedSubmit.submitter);
    });
  }
})();
